import React, {useEffect} from "react"
import {useNavigate} from "react-router-dom";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {useSearchParams} from 'react-router-dom';
import Typography from '@mui/material/Typography';

import {
  ButtonTypeEnum, ButtonSizeEnum, ButtonColorEnum
} from "components/shared/enums/global-enums.tsx";

import AppButton from "components/shared/AppButton/AppButton"
import { useTranslation } from 'react-i18next';
import variables from "utils/_variables.module.scss";
import {dateInFormat} from "utils/helperFunctions.js";

import useStore from "store/store";
import './SelectFlight.scss'


export default function SelectFlight(){
  const {t} = useTranslation();
  const navigate = useNavigate();
  let storeActions = useStore((state)=> state.actions);

  let [, setSearchParams] = useSearchParams();

  const flightRecordAttempt = useStore((state)=> state.flightRecordAttempt);
  const flights = useStore((state)=> state.flights);

  useEffect(()=>{
    if (!flightRecordAttempt.airline){
      navigate("/");
    }
  }, [flightRecordAttempt, navigate]);


  function handleChoosenFlight(flight){
    storeActions.setFlightRecordAttempt({ ...flightRecordAttempt, flight: flight });
  }
         
 

  function handleBack(argument) {
    storeActions.setFlightRecordAttempt({ ...flightRecordAttempt, flight: null });
    setSearchParams(params => {
      params.delete("selectFlight");
      params.set("chooseAirlinePanel", 1);
      return params;
    });
  }

  function handleGo(argument) {
    setSearchParams(params => {
      params.delete("selectFlight");
      params.set("departureDate", 1);
      return params;
    });
  }


  useEffect(()=>{
    if (flightRecordAttempt?.airline){
      storeActions.fetchFlights({airline_id: flightRecordAttempt.airline.id});
    }
  }, [storeActions, flightRecordAttempt]);




  return (
    <Box className="select-flight-container">

      <Typography variant="span" className="h6 font-1-heavy primary1-color">
        {t("Select your flight:")}
      </Typography>

      <div className="v-space-7"></div>
      {flightRecordAttempt?.airline?.name && <img src={require(`assets/images/airlines/${flightRecordAttempt.airline.name}.png`)} height="35" className="d-f c-el " alt="" />}
      <div className="v-space-7"></div>

      <Grid container spacing={4}>
        {flights.map((flight, key) => (
          <Grid item xs={6} sm={6} md={6} lg={6} key={key} >
            <div
              className={`img-btn ${flightRecordAttempt?.flight?.id === flight.id ? 'active': ''}`}
              onClick={()=>handleChoosenFlight(flight)}
              >
              <div className="font-1-heavy h6 upper">{flight.flight_number}</div>
              <div className="font-1-book para2 upper">{t("To")} {flight.arrival_airport.city}</div>
              <div className="font-1-book para2 upper">{t("Departs")} {

                  dateInFormat(flight.departure_at, flight.departure_timezone, "HH:mm")

                }</div>
            </div>
          </Grid>
        ))}
      </Grid>

      <div className="v-space-7"></div>

      <Grid container spacing={4}>
        <Grid item xs={6} sm={6} md={6} lg={6} >
        <AppButton 
          sx={{width: '100%', color: variables['primary4-color']}}
          buttonLabel={ t("Back") }
          buttonColor={ButtonColorEnum.PRIMARY2_BG}
          buttonType={ButtonTypeEnum.PRIMARY}
          buttonSize={ButtonSizeEnum.MEDIUM}
          onClickFunc={handleBack}
        />
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} >
          {
            flightRecordAttempt?.flight?.id &&
            <AppButton 
              sx={{width: '100%'}}
              buttonLabel={ t("Go!") }
              buttonType={ButtonTypeEnum.PRIMARY}
              buttonSize={ButtonSizeEnum.MEDIUM}
              onClickFunc={handleGo}
            />
          }
        </Grid>
      </Grid>

      <div className="v-space-7"></div>
   
    </Box>
    )
}